const statusLabel = {
  title: 'In progress',
  title1: 'Overdue',
  title2: 'Called off',
  title3: 'Done',
};

export default statusLabel;
